export default {
  img: {
    height: '200px',
    width: '200px'
  }
}
